import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDocuments } from "../../api/adminApi";
import EmptyStateCard from "../common/EmptyStateCard";
import { SkeletonCard } from "../common/SkeletonBlock";
import { Icon } from "@iconify/react";

function formatDateTime(value) {
  if (!value) return "-";

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
  }).format(d);
}

export default function RecentDocumentsPanel() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);
      const res = await getDocuments();
      setDocs(res.data || []);
    } catch (e) {
      console.error("Failed to load recent documents", e);
    } finally {
      setLoading(false);
    }
  };

  const recentDocs = useMemo(() => {
    return [...docs].slice(0, 5);
  }, [docs]);

  if (loading) {
    return <SkeletonCard lines={5} titleWidth="42%" />;
  }

  return (
    <div className="card">
      {recentDocs.length === 0 ? (
        <EmptyStateCard
          icon={<Icon icon="pajamas:documents" width="24" height="24" />}
          title="No recent documents"
          message="Upload your first PDF from the Documents page to begin a signing workflow."
          action={
            <button
              className="btn btn-primary"
              onClick={() => navigate("/documents")}
            >
              Go to Documents
            </button>
          }
        />
      ) : (
        <div className="recent-doc-list">
          {recentDocs.map((doc) => (
            <div key={doc.id} className="recent-doc-item">
              <div className="recent-doc-main">
                <div className="recent-doc-title">{doc.name}</div>
                <div className="recent-doc-meta">
                  <span
                    className={`badge badge-${String(doc.status).toLowerCase()}`}
                  >
                    {doc.status}
                  </span>
                  <span className="recent-doc-meta-text">
                    Revision {doc.revisionNo || 1}
                  </span>
                  <span className="recent-doc-meta-text">
                    {formatDateTime(doc.createdAt)}
                  </span>
                </div>
              </div>

              <button
                className="btn btn-secondary"
                onClick={() => navigate(`/documents/${doc.id}`)}
              >
                Open
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
